import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import axiosHttp, { setAuthToken } from "../services/interceptor.service";
import axiosHttpReferesh from "../services/interceptor.refersh";
import { message } from "antd";
import useNotifications from "../hooks/useNotifications";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [accessToken, setAccessToken] = useState(localStorage.getItem("token") || null);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(localStorage.getItem("userId") || null);

  // Initialize notifications for logged-in user
  const { registerFCM } = useNotifications(userId);

  // Set initial token if it exists
  useEffect(() => {
    const token = localStorage.getItem("token");
    const role = localStorage.getItem("role");
    if (token) {
      setAuthToken(token);
    }
    if (role && Number(role) === 6) {
      axiosHttp.defaults.baseURL = process.env.REACT_APP_FINANCE_BASE_URL;
    } else {
      axiosHttp.defaults.baseURL = process.env.REACT_APP_BASE_URL;
    }
  }, []);

  const commonLogin = async (data) => {
    console.log("sampleee", data);
    let response;
    try {
      // Ensure login always goes to the main backend regardless of current baseURL setting
      const rawResponse = await axios.post(`${process.env.REACT_APP_BASE_URL}lmt/login`, data);
      const response = rawResponse.data;
      console.log("responseresponse", response);
      setAccessToken(response?.data?.accessToken);
      setAuthToken(response?.data?.accessToken);

      // Save token to localStorage IMMEDIATELY to avoid race conditions with useNotifications
      if (response?.data?.accessToken) {
        console.log('💾 [AuthProvider] Saving token to localStorage:', response.data.accessToken.substring(0, 10) + '...');
        localStorage.setItem("token", response.data.accessToken);
        if (response.data.id) {
          localStorage.setItem("userId", response.data.id);
        }
        if (response.data.role) {
          localStorage.setItem("role", response.data.role);
          if (Number(response.data.role) === 6) {
            axiosHttp.defaults.baseURL = process.env.REACT_APP_FINANCE_BASE_URL;
          } else {
            axiosHttp.defaults.baseURL = process.env.REACT_APP_BASE_URL;
          }
        }
      }

      // Set userId to trigger notification initialization
      if (response?.data?.id) {
        console.log('🔐 [AuthProvider] Setting userId for notifications:', response.data.id);
        setUserId(response.data.id);

        // MANUALLY trigger registration to ensure it runs
        setTimeout(() => {
          console.log('👉 [AuthProvider] Manually triggering FCM registration');
          registerFCM(response.data.id);
        }, 1000);
      }

      return response;
    } catch (error) {
      console.error("Login failed", error);
      return { message: error.response?.data?.message || error.message };
    }
  };

  const refreshToken = async () => {
    try {
      const response = await axiosHttpReferesh.get("/lmt/refresh");
      console.log("response", response);
      console.log("responseccessToken", response.accessToken);
      setAccessToken(response.accessToken);
      setAuthToken(response.accessToken);
      return response.accessToken;
    } catch (error) {
      console.error("Failed to refresh token", error);
      // setAccessToken(null);
    }
  };

  const logout = async () => {
    try {
      await axios.post(
        "http://localhost:5000/auth/logout",
        {},
        { withCredentials: true }
      );
      setAccessToken(null);
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  useEffect(() => {
    refreshToken().finally(() => setLoading(false));
  }, []);

  return (
    <AuthContext.Provider value={{ accessToken, commonLogin, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
